import groupBy from "lodash-es/groupBy";
import sortBy from "lodash-es/sortBy";
import { useState } from "react";
import styled from "styled-components";

import { ErrorView } from "common/components/error";
import { REPORT_FETCH } from "common/actions/reports";
import { Loader } from "common/helpers/HorizontalLoader";

import { DashboardWidget } from "./widget";

const getStatusValue = (status) => {
    const statusNum = {
        error: 0,
        warn: 1,
        ok: 2
    };
    return statusNum[status] || 3;
};

export function AdminDashboard(props) {
    const [reportStatus, setReportStatus] = useState({
        status: "loading",
        widgets: null,
        error: null
    });
    
    const sortWidgetData = (data) => {
        const byStatus = groupBy(data, "status");
        let result = [];
        Object.keys(byStatus).forEach((status) => {
            result = result.concat(...sortBy(byStatus[status], "title"));
        });
        return result.sort((a, b) => (getStatusValue[a.status] < getStatusValue[b.status] ? 1 : -1));
    };
    
    const getDashBoardRpt = () => {
        REPORT_FETCH({
            id: "monitoring__dashboard_widgets",
            page: 1
        }).then((data) => {
            setReportStatus({
                status: "loaded",
                widgets: sortWidgetData(data.results)
            });
        }, (error) => {
            setReportStatus({
                status: "error",
                error,
                widgets: null
            });
        });
    };
    
    const getCards = () => {
        if (reportStatus.error) {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <ErrorView
                        custom
                        error={reportStatus.error}
                        message="Oops. We were unable to load the dashboard."
                        captureInSentry
                    />
                </div>
            );
        }
        if (reportStatus.widgets) {
            return reportStatus.widgets.map((w) => DashboardWidget(w));
        }
        return null;
    };
    
    if (reportStatus.status === "loading") {
        getDashBoardRpt();
    }
    
    const loaderStyle = {
        paddingTop: "10px",
        width: "100%",
        height: "500px"
    };
    return (
        <Container >
            <Loader style={loaderStyle} loaded={reportStatus.status === "loaded" || reportStatus.status === "error"}>
                {getCards()}
            </Loader>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
`;
